import router from "../../router";
import axios from 'axios';
const noretryAuthAxios = axios.create();
noretryAuthAxios.defaults.baseURL = 'https://api.piachu.net/';

//const state = {
//};
 
//const mutations = {
//};

const actions = {

    async send_comment ({ commit }, payload) {
        return await axios.post('/api/product_comment', {
            product_comments_id: payload.product_comments_id,
            delete: payload.delete,
            contents: payload.contents,
            products_id: payload.products_id,
        }).then(res => {
            return res;
        }).catch(error => {
            return error;
        });
    },

    async new_product ({ commit }, payload) {
        await new Promise((resolve, reject) => {
            axios.post('/api/product', {
                product: payload.product
            }).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },

    async get_ranking ({ commit }, payload) {
        var params = '?type='+payload.type;
        return new axios.get('/api/ranking'+params)
        .catch(error => {
            reject(error);
        })
    },

    async get_products ({ commit }, payload) {
        var params = '?type='+payload.type+'&sort='+payload.sort;
        return new axios.get('/api/products'+params)
        .catch(error => {
            reject(error);
        })
    },

    async get_top_products ({ commit }, payload) {
        var params = '?type='+payload.type+'&sort='+payload.sort;
        return new axios.get('/api/top/products'+params)
        .catch(error => {
            reject(error);
        })
    },

    async get_product ({ commit }, payload) {
        return new axios.get('/api/product/'+payload.id)
        .catch(error => {
            reject(error);
        })
    },

    async get_product_detail ({ commit }, payload) {
        return new axios.get('/api/product/detail/'+payload.id)
        .catch(error => {
            reject(error);
        })
    },

    async upd_product ({ commit }, payload) {
        await new Promise((resolve, reject) => {
            axios.put('/api/product', {
                product: payload.product
            }).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },
    
    async upd_product_status ({ commit }, payload) {
        await new Promise((resolve, reject) => {
            axios.put('/api/product_status', {
                product: payload.product
            }).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },

    async upd_favorite ({ commit }, payload) {
        await new Promise((resolve, reject) => {
            axios.put('/api/favorite', {
                type: payload.type,
                products_id: payload.products_id,
                sellers_id: payload.sellers_id,
                // users_id: payload.users_id,
            }).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },

    async get_product_comments ({ commit }, payload) {
        let params = "";
        if ( payload.searchForm != null ) {
            params = "?admin=1";
            if ( payload.searchForm.id != "" ) {
                params += "&id="+payload.searchForm.id;
            }
            if ( payload.searchForm.name != "" ) {
                params += "&name="+payload.searchForm.name;
            }
            if ( payload.searchForm.mail != "" ) {
                params += "&mail="+payload.searchForm.mail;
            }
        }
        return new axios.get('/api/product_comments'+params)
        .catch(error => {
            reject(error);
        })
    },

    async get_reviews ({ commit }, payload) {
        var params = '';
        if ( payload.id != null ) {
            params += '?id='+payload.id;
        } else {
            params += '?id=';
        }
        if ( payload.freeword != null ) {
            params += '&freeword='+payload.freeword;
        } else {
            params += '&freeword=';
        }
        return new axios.get('/api/reviews'+params)
        .catch(error => {
            reject(error);
        })
    },













































    async evaluate ({ commit }, payload) {
        await new Promise((resolve, reject) => {
            axios.post('/api/evaluate/'+payload.users_id, {
                reviewData: payload.reviewData,
            }).then(res => {
                resolve(res);
            }).catch(error => {
                reject(error);
            });
        });
    },
 
    async get_subject_detail ({ commit }, payload) {
        return new axios.get('/api/evaluate/' + payload.users_id + '?tpe=' + payload.hash_param)
        .catch(error => {
            reject(error);
        });
    },
    

};

export default {
    namespaced: true,
//    state,
//    mutations,
    actions
};



// WEBPACK FOOTER //
// ./src/store/modules/product.js